// extracted by mini-css-extract-plugin
export var container = "Voittoviesti-module--container--cE-7I";